import React from 'react'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import styles from './AboutMedicalHarbour.module.css'

const AboutMedicalHarbour = () => {
  const { t } = useTranslation()

  return (
    <div className="mw-unsigned mx-auto">
      <section className={styles.wrapper}>
        <div className={styles.topRow}>
          <Image
            src="/assets/images/logo-medical-harbour.png"
            alt="Logo Medical Harbour"
            width={100}
            height={100}
            className={styles.logo}
          />
          <span className={`${styles.text} ${styles.desktopOnly}`}>
            {t('subtitles.aboutMedicalHarbourDesktop1')}
            <br />
            {t('subtitles.aboutMedicalHarbourDesktop2')}
            <br />
            {t('subtitles.aboutMedicalHarbourDesktop3')}
          </span>
          <span className={`${styles.text} ${styles.mobileOnly}`}>
            {t('subtitles.aboutMedicalHarbour1')}
            <br />
            {t('subtitles.aboutMedicalHarbour2')}
            <br />
            {t('subtitles.aboutMedicalHarbour3')}
          </span>
        </div>
        <div className={styles.logosRow}>
          <Image
            className={`${styles.partnerLogo} ${styles.bioatlas}`}
            src={`${process.env.CDN_URL}/public/logos/bioatlas.svg`}
            alt="BioAtlas logo"
            width={140}
            height={50}
          />
          <Image
            className={`${styles.partnerLogo} ${styles.bioatlasvet}`}
            src="/assets/images/logo-bioatlasvet.png"
            alt="BioAtlas Vet logo"
            width={140}
            height={50}
          />
          <Image
            className={`${styles.partnerLogo} ${styles.athenahub}`}
            src="/assets/images/logo-athena-hub.png"
            alt="Athena Hub logo"
            width={140}
            height={50}
          />
        </div>
      </section>
    </div>
  )
}

export default AboutMedicalHarbour
